export function measurementsAction() {
  const { t } = useI18n();
  const viewerDistanceMeasurementsStore = useViewerDistanceMeasurementsStore();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.measurements') || 'Measurements',
    doAction: () => {
      // Does nothing
    },
    items: [
      // Sub-menu
      [
        {
          getTitle: () => {
            return t('components.xeokit_viewer.context_menu.delete_all') || 'Delete All';
          },
          getEnabled: () => {
            return viewerDistanceMeasurementsStore.getNumMeasurements() > 0;
          },
          doAction: () => {
            viewerDistanceMeasurementsStore.clearMeasurements();
          },
        },
        {
          getTitle: () => {
            return viewerDistanceMeasurementsStore.getMeasurementsAxisVisible()
              ? t('components.xeokit_viewer.context_menu.hide_measurement_axis_wires') ||
                  'Hide Axis Wires'
              : t('components.xeokit_viewer.context_menu.show_measurement_axis_wires') ||
                  'Show Axis Wires';
          },
          getEnabled: () => {
            return viewerDistanceMeasurementsStore.getNumMeasurements() > 0;
          },
          doAction: () => {
            viewerDistanceMeasurementsStore.setMeasurementsAxisVisible(
              !viewerDistanceMeasurementsStore.getMeasurementsAxisVisible(),
            );
          },
        },
        {
          getTitle: () => {
            return t('components.xeokit_viewer.context_menu.show_all') || 'Show All';
          },
          getEnabled: () => {
            return viewerDistanceMeasurementsStore.getNumMeasurements() > 0;
          },
          doAction: () => {
            viewerDistanceMeasurementsStore.setMeasurementsVisible(true);
          },
        },
        {
          getTitle: () => {
            return t('components.xeokit_viewer.context_menu.hide_all') || 'Hide All';
          },
          getEnabled: () => {
            return viewerDistanceMeasurementsStore.getNumMeasurements() > 0;
          },
          doAction: () => {
            viewerDistanceMeasurementsStore.setMeasurementsVisible(false);
          },
        },
        {
          getTitle: () => {
            return t('components.xeokit_viewer.context_menu.show_all_labels') || 'Show All Labels';
          },
          getEnabled: () => {
            return viewerDistanceMeasurementsStore.getNumMeasurements() > 0;
          },
          doAction: () => {
            viewerDistanceMeasurementsStore.setLabelsShown(true);
          },
        },
        {
          getTitle: () => {
            return t('components.xeokit_viewer.context_menu.hide_all_labels') || 'Hide All Labels';
          },
          getEnabled: () => {
            return viewerDistanceMeasurementsStore.getNumMeasurements() > 0;
          },
          doAction: () => {
            viewerDistanceMeasurementsStore.setLabelsShown(false);
          },
        },
        {
          getTitle: () => {
            return viewerDistanceMeasurementsStore.getMeasurementsSnappingEnabled()
              ? t('components.xeokit_viewer.context_menu.disable_measurement_snapping') ||
                  'Disable Snapping'
              : t('components.xeokit_viewer.context_menu.enable_measurement_snapping') ||
                  'Enable Snapping';
          },
          getEnabled: () => {
            return viewerDistanceMeasurementsStore.getNumMeasurements() > 0;
          },
          doAction: () => {
            viewerDistanceMeasurementsStore.setMeasurementsSnappingEnabled(
              !viewerDistanceMeasurementsStore.getMeasurementsSnappingEnabled(),
            );
          },
        },
      ],
    ],
  };
}
